import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  loginController: [
    'runtimeConstant',
    'webApiSettings',
    '$scope',
    '$rootScope',
    '$location',
    '$window',
    'authService',
    '$state',
    '$timeout',
    '$filter',
    '$uibModal',
    function (
      runtimeConstant,
      webApiSettings,
      $scope,
      $rootScope,
      $location,
      $window,
      authService,
      $state,
      $timeout,
      $filter,
      uibModal
    ) {
      'use strict';

      function requestPermission() {
        return new Promise(function (resolve, reject) {
          const permissionResult = Notification.requestPermission(
            function (result) {
              // Handling deprecated version with callback.
              resolve(result);
            }
          );

          if (permissionResult) {
            permissionResult.then(resolve, reject);
          }
        }).then(function (permissionResult) {
          if (permissionResult !== 'granted') {
            throw new Error('Permission not granted.');
          }
        });
      }

      function init() {
        $scope.validateAbase();
        angular.element(document.querySelector('#chatbox')).remove();
      }

      function keyPress(e) {
        // keyCode == ENTER
        if (e.keyCode === 13) {
          $scope.login();
        }
      }

      function validateAbase() {
        angular.element(document.querySelector('#footer')).empty();
        $state.current.abase = false;

        if (webApiSettings.detailsCompany === 'abase') {
          $state.current.abase = true;
          $rootScope.title = 'Abs-DOC - Login';

          angular
            .element(document.querySelector('#socialmedia1'))
            .append(
              '<a class="btn btn-primary" id="socialmedia1" href="https://www.linkedin.com/company/abase-sistemas-e-soluções-ltda/" target="_blank"><i class="fa fa-linkedin"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia2" href="https://pt-br.facebook.com/abasesistemas/" target="_blank"><i class="fa fa-facebook-square"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia3" href="https://www.instagram.com/abasesistemas/" target="_blank"><i class="fa fa-instagram"></i></a>'
            );
          angular
            .element(document.querySelector('body'))
            .before(
              '<style>body.login-content:before{background: rgb(50, 134, 184) url("../../assets/images/logo/abase.png") no-repeat !important; margin: auto !important;  background-position: center 20% !important; background-size: 18% !important;}</style>'
            );

          angular
            .element(document.querySelector('#footer'))
            .append('Abase Sistemas');
        }
        if (webApiSettings.detailsCompany === 'hdoc') {
          $state.current.hdoc = true;
          $rootScope.title = 'H5 Soluções - Login';

          angular
            .element(document.querySelector('#socialmedia1'))
            .append(
              '<a class="btn btn-primary" id="socialmedia1" href="https://www.linkedin.com/company/h5-solutions/about/" target="_blank"><i class="fa fa-linkedin"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia2" href="https://www.facebook.com/h5solucoes" target="_blank"><i class="fa fa-facebook-square"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia3" href="https://www.instagram.com/h5solucoes/" target="_blank"><i class="fa fa-instagram"></i></a>'
            );

          angular
            .element(document.querySelector('body'))
            .before(
              '<style>body.login-content:before{background: rgb(50, 134, 184) url("../../assets/images/logo/logo_branca_HDOC.png") no-repeat !important; margin: auto !important;  background-position: center 10% !important; background-size: 10% !important;}</style>'
            );
          angular.element('#footer').append('H5 Soluções');
        }
        if (webApiSettings.detailsCompany === 'digitaldoc') {
          $state.current.digitaldoc = false;
          $rootScope.title = 'Digitaldoc - Login';

          angular
            .element(document.querySelector('#socialmedia1'))
            .append(
              '<a class="btn btn-primary" id="socialmedia1" href="https://www.linkedin.com/company/digitaldoc/" target="_blank"><i class="fa fa-linkedin"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia2" href="https://www.facebook.com/digitaldocbr/" target="_blank"><i class="fa fa-facebook-square"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia3" href="https://www.instagram.com/digitaldocbr/" target="_blank"><i class="fa fa-instagram"></i></a>'
            );

          angular
            .element(document.querySelector('#footer'))
            .append('© Digitaldoc');
        }
        if (webApiSettings.detailsCompany === 'rb') {
          $state.current.rb = true;
          $rootScope.title = 'RB - Login';

          angular
            .element(document.querySelector('#socialmedia1'))
            .append(
              '<a class="btn btn-primary" id="socialmedia1" href="https://www.linkedin.com/company/rbsolu%C3%A7%C3%B5es/" target="_blank"><i class="fa fa-linkedin"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia2" href="https://www.facebook.com/rbsolucoesetecnologia/" target="_blank"><i class="fa fa-facebook-square"></i></a>' +
                ' ' +
                '<a class="btn btn-primary" id="socialmedia3" href="https://www.instagram.com/rbsolucoesetecnologia/" target="_blank"><i class="fa fa-instagram"></i></a>'
            );
          angular
            .element(document.querySelector('body'))
            .before(
              '<style>body.login-content:before{background: rgb(50, 134, 184) url("../../assets/images/logo/rb.png") no-repeat !important; margin: auto !important;  background-position: center 5% !important; background-size: 10% !important;}</style>'
            );
          angular.element(document.querySelector('#footer')).append('© RB');
        }
      }

      function autoLogin() {
        if ($state && $state.params && $state.params.code) {
          swal.fire({
            title: $filter('translate')('WAIT LOGIN'),
            text: $filter('translate')('WAIT LOGIN MSG'),
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            icon: 'info',
          });

          $scope.autoLoginToken = $state.params.code;
          authService.autoLogin($scope.autoLoginToken).then(
            function () {
              //Abrir o home
              $rootScope.onLogin = false;

              $state.go('home.list');

              // $location.path('/');
              // $location.search('');

              swal.close();
            },
            function (err) {
              $timeout(function () {
                swal
                  .fire({
                    title: err.error,
                    text: $filter('translate')('AUTOLOGIN NOT FOUND'),
                    icon: 'error',
                  })
                  .then(function () {
                    $timeout(function () {
                      $state.go('login');
                      // $location.path('/login');
                      $scope.focusPassword = true;
                    });
                  });
              });
            }
          );
        }
      }

      function cancelButton() {
        $scope.errorModal.close();
      }

      function login() {
        $scope.focusPassword = false;

        if ($scope.idle === true) {
          return;
        }

        $scope.idle = true;

        swal.fire({
          title: $filter('translate')('WAIT LOGIN'),
          text: $filter('translate')('WAIT LOGIN MSG'),
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          icon: 'info',
          timer: 5000,
        });

        authService.login($scope.loginData).then(
          function () {
            // Abrir o home
            $scope.auth = authService.authentication.isAuth;

            $rootScope.onLogin = false;
            // Carrega o usuário para verificar se precisa alterar a senha
            authService.loadUser().then(function (user) {
              $rootScope.user = user;
              requestPermission();

              if (user.changePass) {
                $timeout(function () {
                  $scope.changePassModal = uibModal.open({
                    animationEnabled: true,
                    templateUrl: '/views/partials/changePass.html',

                    controller: 'userController',
                    windowClass: 'modalChangePass',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                      isChangeOnLogin: function () {
                        return true;
                      },
                      currentPass: function () {
                        return user.pass;
                      },
                    },
                  });

                  $scope.changePassModal.result.then(
                    function () {
                      $rootScope.user = authService.user;
                      $scope.goToHome();
                    },
                    function () {
                      authService.logOut();
                      $rootScope.onLogin = true;
                      $scope.idle = false;
                      return;
                    }
                  );
                });
              } else {
                $scope.goToHome();
              }
            });
            swal.close();
          },
          function (err) {
            $scope.idle = false;

            $timeout(function () {
              $scope.messageTitle = err.error;
              $scope.messageDescription = $filter('translate')(
                'USER.AND.PASSWORD.INVALID'
              );
              $scope.messageCancel = 'OK';
              swal.close();
              $scope.errorModal = uibModal.open({
                scope: $scope,
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'loginController',
                backdrop: 'static',
                keyboard: true,
                size: 'm',
              });
            });
          }
        );
      }

      function is390Visible() {
        var width = $window.innerWidth;
        return width > 767 || (width <= 600 && width > 500);
      }

      function is500Visible() {
        var width = $window.innerWidth;
        return width <= 767 && width > 600;
      }

      function is300Visible() {
        var width = $window.innerWidth;
        return width <= 500 && width > 400;
      }

      function is220Visible() {
        var width = $window.innerWidth;
        return width <= 400;
      }

      function goToHome() {
        if ($scope.loginData.returnUrl !== null) {
          var url = $scope.loginData.returnUrl.replace('#', '');
          $location.path(url);
          if (url && !url.contains('view/')) {
            $location.search('redirecting=1');
          } else {
            $location.search('');
          }
        } else {
          $location.path('/');
          $location.search('');
        }
      }

      function run() {
        try {
          $rootScope.onLogin = true;
          $rootScope.title = '- Login';
          $scope.autoLoginToken = '';
          $scope.auth = false;
          $scope.url = '';
          $state.current.abase = false;
          $state.current.hdoc = false;
          $state.current.digitaldoc = false;

          if (
            authService.authentication.isAuth &&
            !($state && $state.params && $state.params.code)
          ) {
            $location.path('/');
          }

          if ($state && $state.params && $state.params.redirectUrl) {
            $scope.url = $state.params.redirectUrl;
          }

          $scope.loginData = {
            email: authService.getLastLoginEmail(),
            password: '',
            rememberMe: false,
            returnUrl: $scope.url,
          };

          $scope.idle = false;
          $scope.focusPassword = $scope.loginData.email !== '';

          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.keyPress = logWrapper(
            keyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateAbase = logWrapper(
            validateAbase,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.autoLogin = logWrapper(
            autoLogin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.login = logWrapper(
            login,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is390Visible = logWrapper(
            is390Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is500Visible = logWrapper(
            is500Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is300Visible = logWrapper(
            is300Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is220Visible = logWrapper(
            is220Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToHome = logWrapper(
            goToHome,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
